import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { FileService } from '../file/file.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FiliDb } from '../interfaces/filiDb.interface';
import { saveAs } from 'file-saver-es';
import { SessionService } from '../session/session.service';

@Component({
    selector: 'file-link',
    template: `
  @if (file) {
    <button type="button" (click)="getFile()" class="btn nowrap-btn" [ngClass]="{'btn-link': !isButton, 'w-100 btn-garanti btn-blue btn-lg': isButton}" [title]="file.beskrivning"><fa-icon [icon]="['fas', style.icon]" size="lg" [fixedWidth]="true" class="me-2" [style.color]="style.color"></fa-icon>{{ caption || ('label.ladda-ner' | translate) }}</button>
  }
  @if (!file) {
    <span class="text-muted">({{ 'label.saknas' | translate }})</span>
  }`,
    styles: [`
  .btn.active.focus, .btn.active:focus, .btn.focus, .btn:active.focus, .btn:active:focus, .btn:focus {
     outline: 0;
     outline-offset: 0;
   }
   .btn-link {
     padding: 0;
   }`],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FileLinkComponent {
  @Input() file: FiliDb;
  @Input() caption: string;
  @Input() isButton: boolean;
  @Output()
  public onSuccess: EventEmitter<any> = new EventEmitter();

  constructor(
    protected fileService: FileService,
    protected sessionService: SessionService,
    protected spinner: NgxSpinnerService) {
  }

  public get style(): { icon: string, color?: string } {
    switch (this.file && this.file.filtillagg ? this.file.filtillagg.toLowerCase() : '') {
      case '.pdf':
        return { icon: 'file-pdf', color: '#cb4d4d' };

      case '.doc':
      case '.docx':
        return { icon: 'file-word', color: '#337ab7' };

      case '.xls':
      case '.xlsx':
        return { icon: 'file-excel', color: '#4dcb4d' };

      default:
        return { icon: 'file' };
    }
  };

  public getFile(): void {

    this.spinner.show();

    this.fileService.getFile(this.sessionService.activeInstance.id, this.file.id).subscribe(
      (response: HttpResponse<ArrayBuffer>) => {
        this.spinner.hide();
        const contentType = response.headers.get('content-type');
        const blob = new Blob([response.body], { type: contentType });
        saveAs(blob, this.file.filnamn + this.file.filtillagg);

        if (this.file != null && !this.sessionService.impersonated) {
          this.file.datumLast = new Date();
        }

        if (this.onSuccess) this.onSuccess.emit();
      },
      (error) => {
        this.spinner.hide();
      });
  }
}
